import {
  resetExperienceCookie,
  setCustomVariables,
  setIsPlusTag,
  setModalZIndexes,
  setUserRef,
} from './utils'

import config from '@config'
import { PianoEvents } from './usePianoEvents'

interface InitializePianoParams {
  isLoggedIn: boolean
  currentUrl: string
  ssoSource: string
  pianoEvents: PianoEvents
  isPlus?: boolean
}

interface UpdatePianoExperienceParams {
  currentUrl: string
  ssoSource: string
  isPlus?: boolean
}

const {
  piano: { applicationId, pianoEndPoint, cxenseSiteId },
} = config

const pianoInit = () =>
  window?.tp?.push?.([
    'init',
    () => {
      window?.tp?.experience?.init?.()
    },
  ])

const initExperience = (isLoggedIn: boolean): void => {
  setModalZIndexes()

  if (isLoggedIn) {
    setUserRef(() => {
      // init piano after having set userRef
      pianoInit()
    })
  } else {
    // on logging out remove previously set experience cookie
    resetExperienceCookie()
    pianoInit()
  }
}

const updateExperience = ({
  currentUrl,
  ssoSource,
  isPlus,
}: UpdatePianoExperienceParams) => {
  // Update global variables in Piano
  setCustomVariables({ currentUrl, sourceSSO: ssoSource })
  setIsPlusTag(isPlus)
  window?.tp?.experience?.execute?.()
}

// apart from the arguments passed by dependency injection, the code below is generated by Piano
const initializePiano = ({
  isLoggedIn,
  currentUrl,
  ssoSource,
  pianoEvents,
  isPlus,
}: InitializePianoParams) => {
  const { onCheckoutClose, onCheckoutCustom, onShowOffer } = pianoEvents

  window.tp?.push(['setAid', applicationId])
  window.tp?.push(['setEndpoint', pianoEndPoint])
  window.tp?.push(['setUseTinypassAccounts', false])

  // Needed for the new piano segmentation engine
  window.tp?.push(['setCxenseSiteId', cxenseSiteId])

  /* checkout related events */
  window.tp?.push(['addHandler', 'checkoutClose', onCheckoutClose])
  window.tp?.push(['addHandler', 'checkoutCustomEvent', onCheckoutCustom])
  window.tp?.push(['addHandler', 'showOffer', onShowOffer])

  // custom variables accessible in Piano templates
  setCustomVariables({ currentUrl, sourceSSO: ssoSource })

  // Set plus tag
  setIsPlusTag(isPlus)

  // Uncomment to use piano debug mode with verbose logging
  // tp.push(['setDebug', true])

  initExperience(isLoggedIn)
}

export { updateExperience, initializePiano }
